import { render, staticRenderFns } from "./AccountGoogleReviewSelect.vue?vue&type=template&id=a1a969c6"
import script from "./AccountGoogleReviewSelect.vue?vue&type=script&lang=js"
export * from "./AccountGoogleReviewSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports